// Shim re-export to preserve existing import path
// The run command has been folderized under ./run/
export { run, run as runCommand } from "./run/index.js";
